<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.93478 11.25H14.3152M8.93478 11.25L7.5 14.25M8.93478 11.25L11.0837 6.75677C11.2569 6.3947 11.3435 6.21367 11.4619 6.15646C11.565 6.10671 11.685 6.10671 11.7881 6.15646C11.9065 6.21367 11.9931 6.3947 12.1663 6.75677L14.3152 11.25M14.3152 11.25L15.75 14.25M0.75 2.25H5.25M5.25 2.25H7.875M5.25 2.25V0.75M7.875 2.25H9.75M7.875 2.25C7.5029 4.46796 6.63944 6.47714 5.37416 8.16332M6.75 9C6.29061 8.79361 5.82199 8.50656 5.37416 8.16332M5.37416 8.16332C4.35977 7.38582 3.45207 6.31998 3 5.25M5.37416 8.16332C4.17064 9.7672 2.60358 11.0789 0.75 12"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
